import { createStore } from 'zustand-x';

export const applicationStore = createStore('application')(
  {
    isApplicationOpen: false,
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  openApplication: () => {
    set.isApplicationOpen(true);
  },
  closeApplication: () => {
    set.isApplicationOpen(false);
  },
}));
